import React from 'react';

import { useTranslation } from 'react-i18next';

type ProcessStep = {
  id: number;
  label: string;
  isActive: boolean;
};

type ProcessProps = {
  currentStep?: number;
};

export const Process = ({ currentStep = 1 }: ProcessProps) => {
  const { t } = useTranslation('cart');

  const steps: ProcessStep[] = [
    { id: 1, label: t('steps.selectProperties'), isActive: currentStep >= 1 },
    { id: 2, label: t('steps.paymentMethod'), isActive: currentStep >= 2 },
    { id: 3, label: t('steps.applicantInfo'), isActive: currentStep >= 3 },
    { id: 4, label: t('steps.contractTime'), isActive: currentStep >= 4 },
    { id: 5, label: t('steps.reviewSubmit'), isActive: currentStep >= 5 },
  ];

  const currentStepData = steps.find((step) => step.id === currentStep);

  return (
    <>
      <div className="flex items-center gap-3 py-5 md:hidden">
        <div className="flex items-center gap-1.5">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`h-1.5 rounded-full transition-all ${
                step.id === currentStep ? 'w-6 bg-primary' : step.isActive ? 'w-1.5 bg-primary' : 'w-1.5 bg-[#EAEAEA]'
              }`}
            />
          ))}
        </div>
        <span className="text-sm font-medium text-gray-900">
          {currentStep}/{steps.length} · {currentStepData?.label}
        </span>
      </div>

      <div className="hidden items-center py-[30px] md:flex">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex items-center gap-x-[10px]">
              <div
                className={`flex h-[22px] w-[22px] items-center justify-center rounded-full text-sm font-medium ${
                  step.isActive ? 'bg-primary text-white' : 'border border-[##EAEAEA] bg-transparent text-[#BEBEBE]'
                }`}
              >
                {step.id}
              </div>

              <span className={`text-b2 font-medium ${step.isActive ? 'text-gray-900' : 'text-[#BEBEBE]'}`}>
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <div className="mx-4 flex flex-1 items-center justify-center text-gray-300">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};
